const apiBase = process.env.VUE_APP_API;
const urls = Object.entries({
  // non-standard apis
  dashboards: 'dashboards',
  kpis: 'kpis',
  // services
  devices: 'devices',
  query: 'query',
  // legacy proxies
  filters: 'legacy/savedSearches',
  settings: 'legacy/settings',
  // @devicepilot
  graphql: 'graphql',
  hint: 'hint',
  kpi: 'kpi',
  telemetry: 'telemetry',
  incidents: 'incidents',
}).reduce((e, [k, v]) => ({ ...e, [k]: `${apiBase}/${v}` }), {});

// The endpoints without the starting "apiBase", having the dictionary like this and then
// altered gives good autocompletion on IDEs
const endpoints = { ...urls };

export default endpoints;
